var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FDEAD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FEFAF5",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 27.167L30.8587 33.835C31.6301 34.375 32.0158 34.6449 32.4353 34.7495C32.8059 34.8419 33.1935 34.8419 33.564 34.7495C33.9836 34.6449 34.3692 34.375 35.1406 33.835L44.6663 27.167M26.933 42.3337H39.0663C41.0265 42.3337 42.0066 42.3337 42.7553 41.9522C43.4139 41.6166 43.9493 41.0812 44.2849 40.4226C44.6663 39.6739 44.6663 38.6938 44.6663 36.7337V29.267C44.6663 27.3068 44.6663 26.3267 44.2849 25.578C43.9493 24.9195 43.4139 24.384 42.7553 24.0485C42.0066 23.667 41.0265 23.667 39.0663 23.667H26.933C24.9728 23.667 23.9927 23.667 23.244 24.0485C22.5855 24.384 22.05 24.9195 21.7145 25.578C21.333 26.3267 21.333 27.3068 21.333 29.267V36.7337C21.333 38.6938 21.333 39.6739 21.7145 40.4226C22.05 41.0812 22.5855 41.6166 23.244 41.9522C23.9927 42.3337 24.9728 42.3337 26.933 42.3337Z",
    stroke: "#FFB500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.4e0232a2bbb1894ff55d24f21e7ac833.svg";
export { ForwardRef as ReactComponent };